var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMessageLinesDuotoneSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-lines-duotone-solid 1",
    clipPath: "url(#clip0_175_4090)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 7C0.5 3.13906 3.63906 0 7.5 0H49.5C53.3609 0 56.5 3.13906 56.5 7V38.5C56.5 42.3609 53.3609 45.5 49.5 45.5H34.3297L20.8 55.65C20.275 56.0437 19.5641 56.1094 18.9625 55.8141C18.3609 55.5187 18 54.9172 18 54.25V45.5H7.5C3.63906 45.5 0.5 42.3609 0.5 38.5L0.5 7ZM14.5 18.375C14.5 19.8297 15.6703 21 17.125 21H39.875C41.3297 21 42.5 19.8297 42.5 18.375C42.5 16.9203 41.3297 15.75 39.875 15.75H17.125C15.6703 15.75 14.5 16.9203 14.5 18.375ZM14.5 28.875C14.5 30.3297 15.6703 31.5 17.125 31.5H29.375C30.8297 31.5 32 30.3297 32 28.875C32 27.4203 30.8297 26.25 29.375 26.25H17.125C15.6703 26.25 14.5 27.4203 14.5 28.875Z",
    fill: "url(#paint0_linear_175_4090)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.5 18.375C14.5 16.9203 15.6703 15.75 17.125 15.75H39.875C41.3297 15.75 42.5 16.9203 42.5 18.375C42.5 19.8297 41.3297 21 39.875 21H17.125C15.6703 21 14.5 19.8297 14.5 18.375ZM14.5 28.875C14.5 27.4203 15.6703 26.25 17.125 26.25H29.375C30.8297 26.25 32 27.4203 32 28.875C32 30.3297 30.8297 31.5 29.375 31.5H17.125C15.6703 31.5 14.5 30.3297 14.5 28.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_175_4090",
    x1: 0.960548,
    y1: 55.9976,
    x2: 67.7649,
    y2: 28.7855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47E4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CCEDD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_4090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageLinesDuotoneSolid);
export default __webpack_public_path__ + "static/media/icon-message-lines-duotone-solid.a2dd3083a99424940a4e0ece02a1fa35.svg";
export { ForwardRef as ReactComponent };